// Portada, entrada, cuenta (marcas), menú de la marca, historial y el marco de los pasos.
export default {
  // Portada y lema
  'Ideas que Generan Oportunidades Reales': 'Ideas that Generate Real Opportunities',
  'Tu equipo de contenido con IA, listo cada mes': 'Your AI content team, ready every month',
  'Tu equipo de contenido con IA, listo cada mes.': 'Your AI content team, ready every month.',
  'Diseños y videos para tus redes, sin complicarte. Hecho para emprendedores de Latinoamérica.':
    'Designs and videos for your social media, without the hassle. Made for small business owners.',
  'Entrar': 'Sign in',
  'Entra con tu correo. Sin contraseñas.': 'Sign in with your email. No passwords.',

  // Entrar
  'No pudimos enviarte el enlace. Revisa el correo y vuelve a intentarlo.':
    "We couldn't send you the link. Check your email address and try again.",
  'Entra con tu correo': 'Sign in with your email',
  'Sin contraseñas. Te mandamos un enlace y listo.': "No passwords. We'll send you a link and that's it.",
  'Tu correo': 'Your email',
  'tunombre@correo.com': 'yourname@email.com',
  'Enviando…': 'Sending…',
  'Enviarme el enlace': 'Send me the link',
  '¡Listo! Revisa tu correo': 'Done! Check your email',
  'Toca el botón del mensaje para entrar. Ábrelo en este mismo dispositivo.':
    'Tap the button in the email to sign in. Open it on this same device.',
  'Usar otro correo': 'Use a different email',
  'Reenviar en {n}s': 'Resend in {n}s',
  'Reenviar': 'Resend',

  // Pagos con Stripe (08-10-2026)
  // Tu estrategia visual (09-10-2026)
  "Tu personaje en serie": "Your character series",
  "El mismo personaje de tu marca en una situación cotidiana distinta cada vez: una pregunta y un remate seco que la gente reconoce.": "Your brand's same character in a different everyday situation each time: a question and a deadpan punchline people recognize.",
  "El episodio {n}: el mismo personaje en otra situación cotidiana.": "Episode {n}: the same character in another everyday situation.",
  "Borrar todas": "Delete all",
  "Sí, borrar todas": "Yes, delete all",
  "¿Borramos las {n} piezas de este mes? Después puedes volver a diseñarlas. No se devuelven los créditos que ya se usaron.": "Delete this month's {n} pieces? You can design them again afterwards. Credits already used aren't refunded.",
  "1 versión": "1 version",
  "Así se ve tu marca": "How your brand looks",
  "Así te va en tus redes": "How your social media is doing",
  "Conservar y mejorar": "Keep and improve",
  "Cómo se ven": "How they look",
  "Hashtags y más": "Hashtags and more",
  "Súbelo": "Upload it",
  "Tu estilo de foto": "Your photo style",
  "Tus mejores publicaciones": "Your best posts",
  "Tus tipografías": "Your fonts",
  "colores": "colors",
  "referencias": "references",
  "versiones del logo": "logo versions",
  "versión del logo": "logo version",
  "{n} capturas": "{n} screenshots",
  "{n} colores": "{n} colors",
  "{n} ejemplos": "{n} examples",
  "{n} hallazgos": "{n} findings",
  "{n} pasos": "{n} steps",
  "{n} por semana": "{n} per week",
  "{n} versiones": "{n} versions",
  "Así suena tu marca": "How your brand sounds",
  "Ver tus respuestas": "See your answers",
  "diferencias": "differentiators",
  "por completar": "to complete",
  "servicio": "service",
  "servicios": "services",
  "Antes y después": "Before and after",
  "Así le vas a hablar a quien te compra": "This is how you'll talk to your buyer",
  "Así se verían en tu feed": "How they'd look in your feed",
  "Así suenas": "How you sound",
  "Así sí, así no": "Do this, not that",
  "Con {marca}": "With {marca}",
  "Dónde lo encuentras": "Where to find them",
  "Dónde rinde cada idea": "Where each idea works best",
  "El momento en que te compra": "The moment they buy",
  "Emociones": "Emotions",
  "Hoy le pasa esto": "Today this happens",
  "Las que rinden en las dos sirven igual para publicar y para pautar.": "Ideas that work in both are good for posting and for ads.",
  "Lo que nunca prometes": "What you never promise",
  "No lo sabe": "Doesn't know",
  "Publicaciones que salen de aquí": "Posts that come from here",
  "Reparto de temas del mes": "This month's topic mix",
  "Solo anuncios": "Ads only",
  "Solo redes": "Social only",
  "Temas": "Topics",
  "Tipos de cliente": "Customer types",
  "Tu estrategia en una mirada": "Your strategy at a glance",
  "cosas que siente": "things they feel",
  "de tus publicaciones": "of your posts",
  "ideas que venden": "ideas that sell",
  "temas del mes": "topics this month",
  "tipos de cliente": "customer types",
  "{emocion} · así lo diría tu cliente": "{emocion} · in your customer's words",
  "{n} emociones": "{n} emotions",
  "{n} perfiles": "{n} profiles",
  "{n} temas": "{n} topics",
  "¿Qué tanto sabe tu cliente?": "How much does your customer know?",
  "Lo que siente tu cliente": "What your customer feels",
  "Ideas que venden": "Ideas that sell",
  "Grupos de WhatsApp": "WhatsApp groups",
  "Eventos y ferias": "Events and fairs",
  "Gremios y cámaras": "Trade groups and chambers",
  "Webinars y charlas": "Webinars and talks",
  "Recomendaciones": "Referrals",
  "Leer menos": "Read less",
  "Leer más": "Read more",
  "Lo que está viviendo": "What they're going through",
  "Quién es": "Who they are",
  "Ver {n} más": "See {n} more",
  "Tu estrategia en 2 minutos": "Your strategy in 2 minutes",
  "Con lo que ya sé de tu negocio, armo tu estrategia": "With what I already know about your business, I build your strategy",
  "A quién le hablas, qué le duele y de qué vas a hablar cada mes. Después la revisas con calma y me pides los cambios que quieras.": "Who you talk to, what hurts them and what you'll talk about each month. Then you review it calmly and ask me for any changes you want.",
  "Esto es lo que vas a recibir": "This is what you'll get",
  "Cuatro partes, cada una en su página para leerla sin prisa.": "Four parts, each on its own page so you can read it without rushing.",
  "Lo estás viendo": "You're viewing it",
  "Una de tus cuentas se desconectó y lo programado en ella no va a salir. Toca «+ Conectar otra», elige esa red y vuelve a entrar: queda reconectada.": "One of your accounts got disconnected and what's scheduled on it won't go out. Tap “+ Connect another”, pick that network and sign in again: it's reconnected.",
  "Por seguridad, las redes piden renovar el permiso cada cierto tiempo. Toca «+ Conectar otra», elige la red marcada y vuelve a entrar antes de la fecha.": "For security, networks ask to renew permission from time to time. Tap “+ Connect another”, pick the marked network and sign in again before the date.",
  "Se desconectó: reconéctala": "Disconnected: reconnect it",
  "Reconéctala antes del {fecha}": "Reconnect it before {fecha}",
  "Tu prueba termina": "Your trial ends",
  "Borrar mi cuenta": "Delete my account",
  "Borra tu cuenta, tus marcas y todo lo que creaste. No se puede deshacer.": "Deletes your account, your brands and everything you created. It can't be undone.",
  "Quiero borrar mi cuenta": "I want to delete my account",
  "Primero cancela tu plan y espera a que termine el periodo pagado. Después podrás borrar tu cuenta.": "First cancel your plan and wait for the paid period to end. Then you can delete your account.",
  "Se borran tu perfil, tus marcas, sus diseños, videos y archivos, y tus créditos. Descarga antes lo que quieras guardar. Los registros de tus pagos se conservan sin tus datos, como pide la ley.": "Your profile, your brands, their designs, videos and files, and your credits are deleted. Download anything you want to keep first. Your payment records are kept without your data, as the law requires.",
  "Escribe tu correo ({correo}) para confirmar": "Type your email ({correo}) to confirm",
  "Borrando…": "Deleting…",
  "Borrar mi cuenta para siempre": "Delete my account forever",
  "Tu cuenta y todo lo tuyo se borraron. Gracias por haber probado IGOR.": "Your account and everything of yours were deleted. Thanks for trying IGOR.",
  "Elegir plan": "Choose a plan",
  "Tu plan terminó. Puedes ver y descargar todo lo tuyo; para seguir creando, elige un plan o recarga créditos.": "Your plan ended. You can see and download everything of yours; to keep creating, choose a plan or top up credits.",
  "No pudimos cobrar tu plan. Actualiza tu tarjeta en Tu perfil para seguir creando; mientras tanto, todo lo tuyo sigue guardado.": "We couldn't charge your plan. Update your card in Your profile to keep creating; meanwhile, everything of yours stays saved.",
  "No pudimos cobrar tu plan. Stripe lo vuelve a intentar solo durante unos días; actualiza tu tarjeta para no perder el plan.": "We couldn't charge your plan. Stripe retries automatically for a few days; update your card so you don't lose your plan.",
  "Actualizar tarjeta": "Update card",
  "Reactivando…": "Reactivating…",
  "Reactivar mi plan": "Reactivate my plan",
  "Listo: tu cambio de plan quedó guardado. Si subiste de plan, los créditos de diferencia aparecen en unos segundos.": "Done: your plan change is saved. If you upgraded, the extra credits show up in a few seconds.",
  "Estamos activando tu pago…": "Activating your payment…",
  "Tu pago está en camino": "Your payment is on its way",
  "¡Listo! Tus créditos ya están en tu cuenta": "Done! Your credits are in your account",
  "¡Listo! Tu plan ya está activo": "Done! Your plan is active",
  "Tu pago se recibió": "We received your payment",
  "Esto tarda unos segundos. No cierres esta página.": "This takes a few seconds. Don't close this page.",
  "Cuando el pago se confirme (por ejemplo, al pagar en OXXO), tus créditos llegan solos y te avisamos.": "Once the payment is confirmed (for example, when you pay at OXXO), your credits arrive automatically and we'll let you know.",
  "Ya puedes seguir creando.": "You can keep creating.",
  "Lo estamos terminando de aplicar. En unos minutos lo verás en Tu perfil; si no aparece, escríbenos a quokka@ideasenmovimiento.com.co.": "We're finishing applying it. You'll see it in Your profile in a few minutes; if it doesn't show up, write to us at quokka@ideasenmovimiento.com.co.",
  "Ir a mis marcas": "Go to my brands",
  "Ver mi plan": "See my plan",
  "No se hizo ningún cobro": "You were not charged",
  "Saliste del pago antes de terminar. Puedes elegir otra vez cuando quieras.": "You left the payment before finishing. You can choose again whenever you like.",
  "Volver a los planes": "Back to plans",
  "Abriendo…": "Opening…",
  "Tarjeta, facturas y cancelar": "Card, invoices and cancel",
  "En cualquier plan. Duran un año y se usan después de los de tu plan.": "On any plan. They last a year and are used after your plan's credits.",
  'No pudimos comprobar que eres una persona. Recarga la página y vuelve a intentarlo.':
    "We couldn't verify that you're a person. Reload the page and try again.",

  // Tema
  'Modo noche': 'Dark mode',
  'Modo día': 'Light mode',

  // Historial
  'Tus últimos dos meses': 'Your last two months',
  'Los textos se guardan siempre. Las imágenes y los videos, dos meses.':
    'Your texts are always kept. Images and videos, for two months.',
  'Cargando…': 'Loading…',
  'Todavía no has terminado ningún mes.': "You haven't finished any month yet.",
  'Es el mes en curso': "It's the current month",
  'Guardado con sus imágenes y videos': 'Saved with its images and videos',
  'Las imágenes y los videos se borran esta semana': 'The images and videos will be deleted this week',
  'Solo quedan los textos': 'Only the texts are left',
  'Se borra pronto': 'Deleting soon',

  // Marco de los pasos
  'Trabajando…': 'Working…',
  'Empezando…': 'Getting started…',
  'Ya estaba trabajando…': 'Already working on it…',
  'Aprobado': 'Approved',
  'Puedes cerrar esta ventana: sigo trabajando y te aviso cuando termine.':
    "You can close this window: I'll keep working and let you know when I'm done.",
  'Intentar de nuevo': 'Try again',
  '‹ Volver al resultado': '‹ Back to the result',
  'Sí, está bien': 'Yes, looks good',
  'Cambiar algo': 'Change something',
  '¿Qué quieres que cambiemos?': 'What would you like us to change?',
  'Rehacer con estos cambios': 'Redo with these changes',
  'Dejarlo así': 'Leave it as is',
  'Todavía no hay nada aquí.': "There's nothing here yet.",
  // Títulos y explicaciones que los pasos le pasan al marco
  'Lo que conocemos': 'What we know',
  'Cuéntanos de tu negocio y revisamos tus redes para entenderlo.':
    "Tell us about your business and we'll look at your social media to understand it.",
  'Tu estrategia': 'Your strategy',
  'Definimos a quién le hablas, qué le duele y de qué vas a hablar cada mes.':
    "We define who you're talking to, what they struggle with, and what you'll talk about each month.",
  'Tus redes hoy': 'Your social media today',
  'Revisamos cómo te va para saber qué te funciona y qué conviene cambiar.':
    "We check how you're doing to see what works for you and what's worth changing.",
  '+ Revisar otra red': '+ Check another account',
  'Tu identidad': 'Your brand identity',
  'Muéstranos tu logo y diseños que te gusten; tus publicaciones se verán de tu marca, y mejor.':
    'Show us your logo and designs you like; your posts will look like your brand, only better.',
  'Tus presentadores': 'Your presenters',
  'Las personas que salen hablando en tus reels. Puedes guardar hasta tres y repartirlas entre tus videos.':
    'The people who appear talking in your reels. You can save up to three and spread them across your videos.',
  'Plan del mes': "Month's plan",
  'Tu calendario: qué publicar, cuándo y en qué formato.': 'Your calendar: what to post, when, and in what format.',
  'Textos': 'Texts',
  'Lo que dice cada publicación del mes, lista para copiar y pegar.':
    "What each of this month's posts says, ready to copy and paste.",
  'Diseños': 'Designs',
  'Tus estáticas y carruseles del mes, con tu estilo y listos para publicar.':
    "This month's images and carousels, in your style and ready to post.",
  'Videos': 'Videos',
  'Tus reels, escena por escena. Tú eliges con qué calidad se hacen y cuántos créditos usan.':
    'Your reels, scene by scene. You choose the quality and how many credits they use.',

  // Menú de la marca
  'Tu marca': 'Your brand',
  'Tu presentadora': 'Your presenter',
  'Planifiquemos tu mes': "Let's plan your month",
  'Publicar': 'Publish',
  'Medición': 'Results',
  'Métricas': 'Metrics',
  'Publicar y medir': 'Publish and measure',
  'Tus fotos y videos reales': 'Your real photos and videos',
  'Meses anteriores': 'Past months',
  'Salir a redes': 'Go live',
  'Abrir el menú': 'Open the menu',
  'Plegar el menú': 'Collapse the menu',
  'Buen día': 'Good morning',
  'Buenas tardes': 'Good afternoon',
  'Buenas noches': 'Good evening',
  'Tus marcas': 'Your brands',
  '‹ Tus marcas': '‹ Your brands',
  'Inicio': 'Home',
  'Listo': 'Done',
  'Seguir con {paso}': 'Continue with {paso}',
  '{hechos} de {total} pasos listos': '{hechos} of {total} steps done',
  '{hechos} de {total} listos': '{hechos} of {total} done',
  'Programar el mes': 'Schedule the month',
  'Todo listo': 'All set',
  'Programa tu mes': 'Schedule your month',
  'Salir': 'Sign out',
  'sin límite': 'unlimited',
  '{n} créditos': '{n} credits',
  'Elige un mes': 'Pick a month',
  'Tus meses': 'Your months',
  'Planear un mes nuevo': 'Plan a new month',

  // Cuenta (marcas)
  'Entendemos tu marca': 'We get to know your brand',
  'Tu negocio, tu cliente, tus redes y tu estilo.': 'Your business, your customer, your social media, and your style.',
  'Planeamos tu mes': 'We plan your month',
  'Qué publicar, cuándo y en qué formato.': 'What to post, when, and in what format.',
  'Creamos el contenido': 'We create the content',
  'Textos, diseños y reels con presentadora.': 'Texts, designs, and reels with a presenter.',
  'Publicamos y medimos': 'We post and measure',
  'Programado en tus redes y con su resultado.': 'Scheduled on your social media, with its results.',
  'Para borrar "{nombre}" y todo su contenido, escribe su nombre exacto:':
    'To delete "{nombre}" and all its content, type its exact name:',
  'mes': 'month',
  'Prueba gratis': 'Free trial',
  'Sin plan': 'No plan',
  'Copia tu enlace:': 'Copy your link:',
  'Tu cuenta': 'Your account',
  'Hola': 'Hi',
  'Hola, {nombre}': 'Hi, {nombre}',
  'IGOR entiende tu marca, planea tu mes, crea los textos, los diseños y los reels, los publica en tus redes y te cuenta cómo les fue.':
    'IGOR gets to know your brand, plans your month, creates the texts, designs, and reels, posts them on your social media, and tells you how they did.',
  'Crear una marca': 'Create a brand',
  'Ocultar': 'Hide',
  'Cómo funciona': 'How it works',
  'piezas programadas en {mes}': 'posts scheduled in {mes}',
  'Estrategia': 'Strategy',
  'Reels con IA': 'AI reels',
  'Programación': 'Scheduling',
  'Crea una marca': 'Create a brand',
  'Te hago las preguntas y armo su estrategia.': "I'll ask you the questions and build its strategy.",
  '¿Cómo se llama el negocio?': "What's the business called?",
  'Nombre del negocio': 'Business name',
  'Crear': 'Create',
  'Tu plan permite 1 marca. Borra una que ya no uses o mejora tu plan para crear otra.':
    "Your plan allows 1 brand. Delete one you don't use anymore or upgrade your plan to create another.",
  'Tu plan permite {n} marcas. Borra una que ya no uses o mejora tu plan para crear otra.':
    "Your plan allows {n} brands. Delete one you don't use anymore or upgrade your plan to create another.",
  'de {n}': 'of {n}',
  'Nueva marca': 'New brand',
  'Tu plan y tus créditos': 'Your plan and credits',
  'créditos disponibles · usaste {usados} y recibiste {recibidos} en {mes}':
    'credits available · you used {usados} and received {recibidos} in {mes}',
  'Plan {nombre}': '{nombre} plan',
  'Tu plan': 'Your plan',
  '{precio} USD al mes': '{precio} USD a month',
  'revisión humana': 'human review',
  'Elige un plan para seguir': 'Choose a plan to continue',
  'Vencen pronto': 'Expiring soon',
  'Termina': 'Ends',
  'Se renueva': 'Renews',
  '{n} el {fecha}': '{n} on {fecha}',
  'Se renueva el {fecha}': 'Renews on {fecha}',
  'Refiere a tus amigos': 'Refer your friends',
  '{n} + {n} créditos': '{n} + {n} credits',
  'Por cada amigo que compre un plan de IGOR, tú recibes {n} créditos y tu amigo también.':
    'For every friend who buys an IGOR plan, you get {n} credits and so does your friend.',
  '¡Copiado!': 'Copied!',
  'Copiar': 'Copy',
  'Te invito a IGOR, tu equipo de contenido con IA. Entra con mi enlace y recibe {n} créditos al comprar tu plan: {enlace}':
    "Join me on IGOR, your AI content team. Sign up with my link and get {n} credits when you buy your plan: {enlace}",
  'Enviar por WhatsApp': 'Send via WhatsApp',
  '1 invitado': '1 invited',
  '{n} invitados': '{n} invited',
  '1 compró': '1 bought',
  '{n} compraron': '{n} bought',
  '¿Te invitó un amigo?': 'Did a friend invite you?',
  'Su código': 'Their code',
  'Código de tu amigo': "Your friend's code",
  'Usar': 'Use',
  'Llegaste con un amigo: al comprar tu plan, cada uno recibe {n} créditos.':
    'You came through a friend: when you buy your plan, you each get {n} credits.',
  '{precio} USD al mes · {n} créditos': '{precio} USD a month · {n} credits',
  'Elige un plan para seguir creando cada mes.': 'Choose a plan to keep creating every month.',
  'Revisión humana': 'Human review',
  'Incluida': 'Included',
  'No incluida': 'Not included',
  'Tu {mes}': 'Your {mes}',
  'programadas': 'scheduled',
  'publicadas': 'published',
  'interacciones': 'interactions',
  'Cada una con su estrategia, su identidad y su propio mes.': 'Each one with its own strategy, look, and month.',
  'Sin definir todavía': 'Not defined yet',
  'Borrar marca': 'Delete brand',
  'Borrar {nombre}': 'Delete {nombre}',
  'Abrir {nombre}': 'Open {nombre}',
  // Contraseña (08-10-2026)
  'Usa al menos 10 caracteres.': 'Use at least 10 characters.',
  'Mezcla letras y números.': 'Mix letters and numbers.',
  'Las dos contraseñas no coinciden.': "The two passwords don't match.",
  'Correo o contraseña incorrectos. Si nunca creaste una contraseña, entra con el enlace al correo.': 'Wrong email or password. If you never created a password, sign in with the email link.',
  'Primero confirma tu correo: toca el botón del mensaje que te enviamos.': 'First confirm your email: tap the button in the message we sent you.',
  'Esa contraseña apareció en filtraciones de otros sitios. Elige otra.': 'That password has appeared in leaks from other sites. Choose another one.',
  'Esa contraseña es muy débil. Usa al menos 10 caracteres con letras y números.': 'That password is too weak. Use at least 10 characters with letters and numbers.',
  'Elige una contraseña distinta a la anterior.': 'Choose a password different from the previous one.',
  'Hiciste muchos intentos seguidos. Espera unos minutos y vuelve a intentarlo.': 'Too many attempts in a row. Wait a few minutes and try again.',
  'No pudimos hacerlo. Vuelve a intentarlo en un momento.': "We couldn't do it. Try again in a moment.",
  'Ver': 'Show',
  'Contraseña nueva': 'New password',
  'Escríbela otra vez': 'Type it again',
  'Al menos 10 caracteres, con letras y números.': 'At least 10 characters, with letters and numbers.',
  'Crea tu contraseña nueva': 'Create your new password',
  'La usarás para entrar con tu correo. También puedes seguir entrando con el enlace o con Google.': 'You will use it to sign in with your email. You can still sign in with the link or with Google.',
  'Guardar y entrar': 'Save and sign in',
  'Este enlace ya no sirve': 'This link no longer works',
  'Los enlaces para crear contraseña vencen en 1 hora y sirven una sola vez. Pide uno nuevo.': 'Password links expire in 1 hour and work only once. Ask for a new one.',
  'Pedir otro enlace': 'Ask for another link',
  'Tu contraseña': 'Your password',
  'Si entras con el enlace al correo o con Google, puedes crear una contraseña para entrar también con ella.': 'If you sign in with the email link or with Google, you can create a password to sign in with it too.',
  'Listo, tu contraseña quedó guardada.': 'Done, your password was saved.',
  'Guardar contraseña': 'Save password',
  'Crear o cambiar contraseña': 'Create or change password',
  'Con un enlace': 'With a link',
  'Con contraseña': 'With a password',
  'Entrando…': 'Signing in…',
  '¿Olvidaste tu contraseña?': 'Forgot your password?',
  'Escribe tu correo y vuelve a tocar «¿Olvidaste tu contraseña?».': 'Type your email and tap “Forgot your password?” again.',
  'Si hay una cuenta con ese correo, te llegó un mensaje para crear una contraseña nueva. El enlace vence en 1 hora.': 'If there is an account with that email, you got a message to create a new password. The link expires in 1 hour.',
  'Con tu correo, con Google o con tu contraseña.': 'With your email, Google or your password.',
  // Portada pública (08-10-2026)
  'Qué hace IGOR por tu negocio': 'What IGOR does for your business',
  'IGOR es una plataforma que te guía paso a paso, con inteligencia artificial, para tener el contenido de tus redes sociales listo cada mes.': 'IGOR is a platform that guides you step by step, with artificial intelligence, so your social media content is ready every month.',
  'Empiezas gratis y sin tarjeta. Tus datos se usan solo para hacer tu contenido: nunca los vendemos.': 'You start free, no card needed. Your data is only used to make your content: we never sell it.',
  'Privacidad': 'Privacy',
  'Términos': 'Terms',
  'Nos cuentas de tu negocio y armamos tu estrategia, el diagnóstico de tus redes y tu identidad visual.': 'You tell us about your business and we build your strategy, your social media diagnosis and your visual identity.',
  'Planeamos qué publicar cada día y en qué red, con los textos listos.': 'We plan what to post each day and on which network, with the copy ready.',
  'Historias, carruseles e imágenes con tus colores, tu logo y tus fotos.': 'Stories, carousels and images with your colors, your logo and your photos.',
  'Videos con presentadora, historias con escenas o textos que se mueven, sin tener que grabar.': 'Videos with a presenter, stories with scenes or moving text, without having to film.',
  'Programamos todo en tus redes y te mostramos cómo le va a cada publicación.': 'We schedule everything on your networks and show you how each post performs.',
  // Prueba gratis una vez (08-10-2026)
  'Ya usaste tu prueba gratis con este correo, así que esta cuenta empieza sin créditos de bienvenida. Elige un plan en Tu perfil para seguir.': 'You already used your free trial with this email, so this account starts without welcome credits. Choose a plan in Your profile to continue.',
  'Hoy se crearon varias cuentas desde tu conexión, así que tu prueba gratis queda en espera. Se activa sola cuando vuelvas a entrar desde otra red (por ejemplo, los datos del celular) o mañana.':
    "Several accounts were created from your connection today, so your free trial is on hold. It turns on by itself when you sign in again from another network (for example, your phone's data) or tomorrow.",
  'Con correos temporales no damos créditos de bienvenida. Entra con tu correo de siempre para usar tu prueba gratis.': "We don't give welcome credits to temporary emails. Sign in with your usual email to use your free trial.",
} satisfies Record<string, string>;
